import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const isTestnet = process.env.REACT_APP_NETWORK_MODE === 'testnet';

  const handleApiDocsClick = (e) => {
    e.preventDefault();
    if (isLoggedIn) {
      navigate("/apis");
    } else {
      toast.info("Please fill this form to get a login ID and password. Then you can access the API documentation.");
      navigate("/inquire-now");
    }
  };

  useEffect(() => {
    document.querySelector("body,html").scrollTop = 0;
    const userIsLoggedIn = localStorage.getItem("token");
    setIsLoggedIn(userIsLoggedIn);
  }, [location]);

  // Add testnet class to body for CSS offsets
  useEffect(() => {
    if (isTestnet) {
      document.body.classList.add('is-testnet');
    } else {
      document.body.classList.remove('is-testnet');
    }
    return () => document.body.classList.remove('is-testnet');
  }, [isTestnet]);

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    } else {
      return location.pathname.startsWith(path);
    }
  };

  return (
    <>
      {/* Testnet Environment Banner */}
      {isTestnet && (
        <div className="testnet-banner">
          <span className="testnet-banner__text">
            <span className="testnet-banner__badge">TESTNET</span>
            Sandbox environment — no real funds are used
          </span>
          <a href="https://paycoinz.com" className="testnet-banner__switch">
            Switch to Production →
          </a>
        </div>
      )}

      <header>
        <div className="container">
          <div className="header-inner">
            <div className="logo" style={{
              width: "100%",
              maxWidth: "180px"
            }}>
              <Link to="/">
                <img src="/images/logo/logo-black.svg" alt="logo" />
              </Link>
            </div>

            {/* Navigation — hidden on testnet */}
            {!isTestnet && (
              <nav className="navbar navbar-expand-lg">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                  <ul className="navbar-nav">
                    <li className="nav-item">
                      <Link
                        to="/about-us"
                        className={`nav-link ${isActive("/about-us") ? "activee" : ""}`}
                        aria-current="page"
                      >
                        About Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/our-services"
                        className={`nav-link ${isActive("/our-services") ? "activee" : ""}`}
                      >
                        Our Services
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/how-it-works"
                        className={`nav-link ${isActive("/how-it-works") ? "activee" : ""}`}
                      >
                        How it works
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="/pricing"
                        className={`nav-link ${isActive("/pricing") ? "activee" : ""}`}
                      >
                        Pricing
                      </Link>
                    </li>
                    <li className="nav-item">
                      <a
                        href="/apis"
                        onClick={handleApiDocsClick}
                        className={`nav-link ${isActive("/apis") ? "activee" : ""}`}
                      >
                        APIs
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
            )}

            <div className="inquire-login-btn">
              {/* Mainnet: show "Try Testnet" button */}
              {!isTestnet && !isLoggedIn && location.pathname !== "/login" && (
                <a href="https://test.paycoinz.com" className="btn try-testnet-btn">
                  Testnet Login
                </a>
              )}

              {/* Inquire Now — only on mainnet */}
              {!isTestnet && !isLoggedIn && (
                <Link to="/inquire-now" className="btn inquire-btn">
                  Inquire Now
                </Link>
              )}

              {isLoggedIn ? (
                <Link to="/dashboard" className="btn login-btn">
                  Dashboard
                </Link>
              ) : (
                <Link to="/login" className="btn login-btn">
                  Log In
                </Link>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
